package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun PrimaryActionButton(
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    text: String,
    textColor: Color = Color.White,
    fontSize: TextUnit = 16.sp,
    transparentBackground: Boolean = false,
    borderWidth: Int = 1,
    onClick: () -> Unit,
    onLongClick: (() -> Unit)? = null, // אופציונלי ללחיצה ארוכה
) {
    val shape = RoundedCornerShape(12.dp)

    // צבע הרקע
    val backgroundColor =
        if (transparentBackground) Color.Transparent
        else colorResource(SharedRes.colors.colorPrimaryDark)

    // Box עם כל העיצוב כמו Button
    Box(
        modifier = modifier
            .conditional(condition = borderWidth != 0) {
                border(
                    width = borderWidth.dp,
                    color = colorResource(SharedRes.colors.strokeColor),
                    shape = shape
                )
            }
            .clip(shape)
            .background(backgroundColor)
            .then(
                if (enabled) {
                    Modifier.combinedClickable(
                        onClick = onClick,
                        onLongClick = onLongClick
                    )
                } else {
                    Modifier // disabled
                }
            )
            .padding(vertical = 8.dp, horizontal = 12.dp) // כמו button content padding
    ) {
        Text(
            text = text,
            fontSize = fontSize,
            style = MaterialTheme.typography.labelLarge,
            textAlign = TextAlign.Center,
            color = if (enabled) textColor else textColor.copy(alpha = 0.4f),
            modifier = Modifier.fillMaxWidth()
        )
    }
}
